// extracted by mini-css-extract-plugin
module.exports = {"text":"Privacy_text__3SoSN","title":"Privacy_title__3fLwj","subTitle":"Privacy_subTitle__25DBA"};